'use client'

import { useLocale } from 'next-intl'
import { CSSProperties } from 'react'

import { useSearchFilterStore } from '@/entities/map'
import { RoomSortOption } from '@/entities/room'
import { Select } from '@/shared/ui'

import { useSortOptionLabelMap } from './options'

type Props = {
  selected?: RoomSortOption
  height?: number
  alignOffset?: number
  className?: string
}

export const OrderFilter = ({ height, alignOffset, className }: Props) => {
  const locale = useLocale()

  const sort = useSearchFilterStore(state => state.sort)
  const filterActions = useSearchFilterStore(state => state.actions)

  const isEnglish = locale === 'en'

  const { SORT_OPTION_LABEL_MAP } = useSortOptionLabelMap()

  const handleValueChange = (newValue: RoomSortOption) => {
    filterActions.updateSort(newValue)
  }

  return (
    <div className={className}>
      <Select.Root
        mode="menu"
        required={true}
        value={sort}
        readOnly={false}
        onValueChange={handleValueChange}
        width={isEnglish ? 146 : 81}
      >
        <Select.Trigger
          variant="text"
          className="h-[var(--select-height)] w-fit justify-start focus-visible:ring-0 focus-visible:outline-none"
          style={{ '--select-height': `${height}px` } as CSSProperties}
        >
          {SORT_OPTION_LABEL_MAP[sort]}
        </Select.Trigger>
        <Select.Content
          variant="text"
          side="bottom"
          shadow
          alignOffset={alignOffset}
          align="end"
          className="min-w-25"
        >
          <Select.Group>
            {Object.entries(SORT_OPTION_LABEL_MAP).map(([value, label]) => (
              <Select.Item key={value} value={value}>
                {label}
              </Select.Item>
            ))}
          </Select.Group>
        </Select.Content>
      </Select.Root>
    </div>
  )
}
